<template>
  <b-card-code title="">
    <b-button style="margin-top: -60px; float: right" variant="primary" @click="showAddModal">إضافة موقع</b-button>
    <vue-good-table
      :columns="columns"
      :rows="this.locations"
      :rtl="direction"
      :lineNumbers="true"
      :search-options="{
        enabled: true
      }"
      :paginationOptions="{
        enabled: true,
        perPage: pageSize
      }"
    >
      <template slot="table-row" slot-scope="props">
        <span v-if="props.column.field === 'action'" class="text-nowrap">
          <!-- style two button for edit and delete -->
          <div class="d-flex justify-content-start">
            <button class="btn btn-primary mr-1" @click="showEditModal(props.row)">
              <feather-icon icon="EditIcon" size="16" />
            </button>
            <DeleteModel :displayName="props.row.name" @confirm-delete="handleDelete(props.row.id)" />
          </div>
        </span>
        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>
      <template slot="pagination-bottom" slot-scope="">
        <div class="d-flex justify-content-between flex-wrap">
          <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap"> عرض الصفحة الأولى </span>

            <b-form-select v-model="pageSize"  :options="['20', '30', '50', '70', '100']" class="mx-1" @change="onPerPageChange" />
            <span class="text-nowrap"> من {{ totalCount }} العناصر </span>
          </div>
          <div>
            <b-pagination
              v-model="pageNumber"
              :total-rows="totalCount"
              :per-page="pageSize"
              first-number
              last-number
              align="right"
              class="mt-1 mb-0"
              @input="handlePageChange"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </div>
        </div>
      </template>
    </vue-good-table>
    <AddLocation
      ref="addEditLocationModal"
      :isEditMode="isEditMode"
      :initialLocation="selectedLocation"
      :modalTitle="modalTitle"
      @location-saved="handleLocationSaved"
    />
  </b-card-code>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { VueGoodTable } from 'vue-good-table'
import BCardCode from '@core/components/b-card-code/BCardCode.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import DeleteModel from '@core/components/DeleteModel.vue'
import AddLocation from './AddLocation.vue'
import store from '@/store'
import {
  BButton,
  BAvatar,
  BBadge,
  BModal,
  VBModal,
  BPagination,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BDropdown,
  BDropdownItem,
  BFormDatepicker
} from 'bootstrap-vue'

export default {
  components: {
    BButton,
    BAvatar,
    BBadge,
    BModal,
    BCardCode,
    DeleteModel,
    VBModal,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BFormDatepicker,
    VueGoodTable,
    AddLocation
  },
  data() {
    return {
      isEditMode: false,
      selectedLocation: {
        id: 0,
        name: '',
        price: 0,
        description: ''
      },
      modalTitle: 'اضافة موقع',

      pageSize: 20,
      pageNumber: 1,

      dir: false,
      columns: [
        {
          label: 'الاسم',
          field: 'name',
          sortable: true
        },
        {
          label: 'التفاصيل',
          field: 'action',
          sortable: false
        }
      ]
    }
  },
  async mounted() {
    await this.getLocationsFromGrid()
  },

  methods: {
    ...mapActions('locations', ['fetchLocationsGrid', 'deleteLocation']),

    async getLocationsFromGrid() {
      await this.fetchLocationsGrid({ pageSize: this.pageSize, pageNumber: this.pageNumber })
    },

    showAddModal() {
      this.isEditMode = false
      this.selectedLocation = {
        id: 0,
        name: '',
        price: 0,
        description: ''
      }
      this.modalTitle = 'اضافة موقع'
      this.$refs.addEditLocationModal.showModal()
    },
    showEditModal(location) {
      this.isEditMode = true
      this.selectedLocation = { ...location }
      this.modalTitle = 'تعديل موقع'
      this.$refs.addEditLocationModal.showModal()
    },

    handleLocationSaved(location) {
      // Handle location saved event (e.g., refresh location list)
      // console.log('Location saved:', location)
    },
    async handlePageChange() {
      await this.getLocationsFromGrid()
    },

    async onPerPageChange(newPerPage) {
      this.pageSize = parseInt(newPerPage, 10)
      await this.getLocationsFromGrid(this.pageSize, this.pageNumber)
    },
    //add toster when delete location is done and if not done show error message
    async handleDelete(id) {
      await this.deleteLocation(id)
        .then(() => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'تم الحذف بنجاح',
              icon: 'TrashIcon',
              variant: 'success'
            }
          })
        })
        .catch(() => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'حدث خطأ أثناء الحذف',
              icon: 'XCircleIcon',
              variant: 'danger'
            }
          })
        })
    }
  },
  computed: {
    ...mapGetters('locations', {
      locations: 'getLocations',
      totalCount: 'totalCountData',
      pagesCount: 'pagesCount'
    }),

    direction() {
      if (store.state.appConfig.isRTL) {
        this.dir = true
        return this.dir
      }
      this.dir = false
      return this.dir
    }
  }
}
</script>

<style>
/* Add your custom styles here */
</style>
